module.exports = __webpack_public_path__ + "media/images/indeed-small-icon-9d338ff28e7225e6d4e6330b1f45e3c2.svg";